import { Modal, Form, Input, Button } from "antd";
import React from "react";
import ModalUtil from "../../util/modal";
import { dissoc } from "ramda";

const FormItem = Form.Item;

const ModalForm = Form.create()(
	class ModalForm extends React.Component {
		render() {
			const {
				visible, confirmLoading, onCancel, oldChoice, newChoice,
				onCreate, form, indexAttr, category_title,
				onSubmitDeleteAttr, onAddChoice, onDeleteChoice
			} = this.props;
			const { getFieldDecorator, getFieldValue } = form;
			return (
				<Modal
					visible={visible}
					title={indexAttr ? "Update Attrbiute" : "Create new Attrbiute"}
					okText={indexAttr ? "Update" : "Create"}
					onCancel={() => {
						onCancel();
					}}
					onOk={() => {
						onCreate();
					}}
					closable={false}
					maskClosable={false}
					confirmLoading={confirmLoading}
				>
					<Form layout="vertical">
						<FormItem label="Attribute Name">
							{getFieldDecorator("attr", {
								initialValue: category_title[`category${indexAttr}_title`] || "",
								rules: [{ required: true, message: "Require Attribute Name!" }],
							})(<Input />)}
						</FormItem>
						{
							oldChoice && oldChoice.map((value, index) => {
								return (
									<FormItem label={`Choice${index + 1}`} key={index}>
										{
											getFieldDecorator(`oldChoice${index + 1}`, {
												initialValue: value.name || "",
												rules: [{ required: true, message: "Require choice name!" }],
											})(<Input />)
										}
									</FormItem>
								);
							})
						}
						{
							newChoice && newChoice.map((value, index) => {
								const i = oldChoice ? oldChoice.length + (index + 1) : index + 1;
								return (
									<FormItem
										label={`Choice${i}`}
										key={index}>
										{
											getFieldDecorator(`newChoice${index + 1}`, {
												initialValue: value.name || "",
												rules: [{ required: true, message: "Require choice name!" }],
											})(<Input />)
										}
									</FormItem>
								);
							})
						}
					</Form>
					<div><a onClick={onAddChoice}>Add new choice</a></div>
					{
						(newChoice && newChoice.length > 1) || (oldChoice && newChoice && newChoice.length > 0) ?
							<div style={{ marginTop: 10 }}>
								<a onClick={onDeleteChoice}>Remove last choice</a>
							</div> :
							null
					}
					{indexAttr &&
                        <div style={{ height: 40 }}>
                        	<Button
                        		onClick={() =>
                        			ModalUtil.showDeleteAttr({
                        				attr: { id: indexAttr, name: getFieldValue("attr") },
                        				onSubmitDeleteAttr: (id) => {
                        					onSubmitDeleteAttr(id).then(res => {
                        						if (res) { onCancel(); this.indexAttr = null; }
                        					});
                        				}
                        			})}
                        		style={{ float: "right" }} type="danger">Delete</Button>
                        </div>
					}
				</Modal>
			);
		}
	}
);

class EmployeeAttr extends React.Component {
    state = {
    	visible: false,
    	indexAttr: null,
    	confirmLoading: false,
    	oldChoice: null,
    	newChoice: null
    };

    onAddChoice = () => {
    	let { newChoice } = this.state;
    	const { confirmLoading } = this.state;
    	if (confirmLoading) return;
    	if (Array.isArray(newChoice)) newChoice.push("");
    	else newChoice = [""];
    	this.setState({ newChoice });
    }

    onDeleteChoice = () => {
    	const { newChoice } = this.state;
    	newChoice.pop();
    	this.setState({ newChoice });
    }

    showModal = (indexAttr, oldChoice) => {
    	if (indexAttr) this.setState({ indexAttr, oldChoice, newChoice: null });
    	else this.setState({ newChoice: [""] });
    	this.setState({ visible: true });

    }
    handleCancel = () => {
    	const { confirmLoading } = this.state;
    	if (confirmLoading) return;
    	this.setState({ visible: false, indexAttr: null, oldChoice: null, newChoice: null });
    	this.form.resetFields();
    }
    handleCreate = () => {
    	const { onSubmitManageAttr, category_title } = this.props;
    	const { indexAttr, oldChoice, newChoice } = this.state;
    	const form = this.form;
    	form.validateFields((err, values) => {
    		if (err) {
    			return;
    		}
    		this.setState({ confirmLoading: true });

    		const packPayload = { name: values.attr };

    		if (indexAttr && oldChoice) {
    			const oldC = oldChoice.map((value, index) => ({ id: value.id, name: values[`oldChoice${index + 1}`] }));
    			const newC = newChoice ? newChoice.map((value, index) => values[`newChoice${index + 1}`]) : [];
    			packPayload.choices = oldC;
    			packPayload.new_choices = newC;
    		} else {
    			const newC = newChoice ? newChoice.map((value, index) => values[`newChoice${index + 1}`]) : [];
    			packPayload.choices = newC;
    		}

    		let title_attr_empty = null;
    		if (!indexAttr) {
    			Object.keys(category_title).map((key, index) => {
    				if (category_title[key] === null && title_attr_empty === null) {
    					title_attr_empty = index + 1;
    				}
    				return null;
    			});
    		}

    		onSubmitManageAttr({ payload: packPayload, id: indexAttr || title_attr_empty }).then(res => {
    			this.setState({
    				visible: false,
    				confirmLoading: false,
    				indexAttr: null,
    				oldChoice: null,
    				newChoice: null,
    			}, () => form.resetFields());
    		});

    	});
    }
    saveFormRef = (form) => {
    	this.form = form;
    }
    render() {
    	const { confirmLoading, oldChoice, newChoice } = this.state;
    	return (
    		<div>
    			<ModalForm
    				ref={this.saveFormRef}
    				visible={this.state.visible}
    				onCancel={this.handleCancel}
    				onCreate={this.handleCreate}
    				indexAttr={this.state.indexAttr}
    				category_title={this.props.category_title}
    				onSubmitDeleteAttr={this.props.onSubmitDeleteAttr}
    				confirmLoading={confirmLoading}
    				oldChoice={oldChoice}
    				newChoice={newChoice}
    				onAddChoice={this.onAddChoice}
    				onDeleteChoice={this.onDeleteChoice}
    			/>
    		</div>
    	);
    }
}

export default EmployeeAttr;


// WEBPACK FOOTER //
// ./src/components/modal/EmployeeAttr.js